import { createSelector } from '@reduxjs/toolkit';
import { RESTING_LEAD_COUNT } from 'features/resting/resting.util';
import { DefaultRootState } from 'react-redux';
import { leadCountSelector } from './signal.selectors';

export const ecgSelector = ({ ecg }: DefaultRootState) => ecg;

export const ecgIdSelector = createSelector(ecgSelector, ({ ecgId }) => ecgId);

export const exactDurationSelector = createSelector(
  ecgSelector,
  ({ duration }) => duration,
);

export const roundedDurationSelector = createSelector(
  ecgSelector,
  ({ duration }) => Math.round(duration),
);

export const holterStripInfoSelector = createSelector(
  ecgSelector,
  ({ holterStripInfo }) => holterStripInfo,
);

export const analysisTypeSelector = createSelector(
  ecgSelector,
  ({ analysisType }) => analysisType,
);

export const pipelineSelector = createSelector(
  ecgSelector,
  ({ pipeline }) => pipeline,
);

export const recordTypeSelector = createSelector(
  ecgSelector,
  ({ recordType }) => recordType,
);

export const holterStripLoadedSelector = createSelector(
  holterStripInfoSelector,
  (holterStripInfo) => holterStripInfo !== undefined,
);

export const errorTypeSelector = createSelector(
  ecgSelector,
  ({ errorType }) => errorType,
);

export const isRestingStripSelector = createSelector(
  leadCountSelector,
  (leadCount) => leadCount === RESTING_LEAD_COUNT,
);

export const sexSelector = createSelector(
  ecgSelector,
  ({ patientInfo }) => patientInfo?.sex,
);

export const ageSelector = createSelector(
  ecgSelector,
  ({ patientInfo }) => patientInfo?.age,
);
